var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.formattedData.length >= 10000)?_c('div',{staticClass:"card-panel red lighten-4"},[_c('h6',[_vm._v("Too much data to plot")])]):_c('HighChart',{attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bcb3316","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/analysis/Histogram.vue
// module id = null
// module chunks = 